import { AxiosError } from "axios";

export const extractAxoisErrorsMessage = (axiosError: AxiosError): string => {
  const axiosMessageData = axiosError?.response?.data as any;
  const descriptionFormated =
    axiosMessageData?.message || axiosMessageData?.error || axiosError.message;

  return descriptionFormated;
};
